<zui-docs-text>
  <zui-internal-link-text
    [disableLink]="disableLink"
    (linkClicked)="linkClicked.emit()">
    <ng-content></ng-content>
  </zui-internal-link-text>
</zui-docs-text>
